import {
    Zone
  } from '../../../../../core';

  export const dispatchZone =  {
    searchText: 'Buscar zona',
    addText: 'Crear zona',
    export: false,
    filter: false, // lista de departamentos
    filterDefault: '',
    checkbox: false,
    disabled: false,
    partialField: 'configuredZones',
    columns: [
      {
        title: 'Código',
        name: 'zoneId',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: Zone) => element.zoneId || element.id
      },
      {
        title: 'Nombre',
        name: 'name',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: Zone) => element.name || element.district
      },
      {
        title: 'Zona',
        name: 'configuredZones',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: Zone) =>
          element.configuredZones && element.configuredZones.length
            ? element.configuredZones[0].name
            : '---'
      },
      {
        title: 'Tipo',
        name: 'zoneTypeDescription',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: Zone) => element.zoneTypeDescription
      },
      {
        title: 'Departamento/Provincia',
        name: 'departmentName',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: Zone) => element.departmentName || element.department
      },
      {
        title: 'Provincia/Cantones',
        name: 'provinceName',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: Zone) => element.provinceName || element.province
      },
      {
        title: 'Canal de venta',
        name: 'saleChannel',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: Zone) => element.saleChannel
      },
      {
        title: 'Estado',
        name: 'active',
        type: 'boolean',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: Zone) => element.active
      }
    ],
    subTable: {}
  };
